<template>
  <button class="menu-button" @click="$emit('click')">
    <template v-if="isCollapsed">
      <div class="menu-button__collapsed-button">
        <div class="button__icon">
          <img :src="CollapsedIconPath" />
        </div>
        <div class="button__text">メニュー</div>
      </div>
    </template>
    <template v-else>
      <div class="menu-button__expanded-button">
        <img :src="ExpandIconPath" />
        <div class="button__text">メニューを閉じる</div>
      </div>
    </template>
  </button>
</template>

<script>
import CollapsedIconPath from '@assets/images/clinic/icons/sidebar_menu_button_collapsed.svg';
import ExpandIconPath from '@assets/images/clinic/icons/sidebar_menu_button_expanded.svg';

export default {
  props: {
    isCollapsed: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      CollapsedIconPath,
      ExpandIconPath,
    };
  },
};
</script>

<style lang="sass" scoped>
.menu-button
  background: none
  cursor: pointer
  border: none
  outline: none
  font-size: 12px
  color: #fff
  padding: 0

  &__collapsed-button
    .button__text
      font-size: 12px

    .button__icon
      margin-bottom: 4px

  &__expanded-button
    display: flex
    align-items: center
    .button__text
      font-size: 12px
      padding-left: 8px
</style>
